// extracted by mini-css-extract-plugin
export default {"container":"backgrounds_container__1h9pr","background":"backgrounds_background__2c5jJ","active":"backgrounds_active__Ana3c"};